export default __webpack_public_path__ + "static/media/gift.df8c9b38.svg";